const SKIP_UNSAVED_CHANGES_CONFIRMATION_KEY = 'skipUnsavedChangesConfirmation';

/**
 * Marks a programmatic navigation so the unsaved-changes guard lets it through,
 * e.g. closing the details sidebar of an entity that is being deleted.
 */
export const withSkipUnsavedChangesConfirmation = (locationState?: unknown): Record<string, unknown> => ({
  ...(locationState instanceof Object ? (locationState as Record<string, unknown>) : {}),
  [SKIP_UNSAVED_CHANGES_CONFIRMATION_KEY]: true,
});

export const isUnsavedChangesConfirmationSkipped = (locationState: unknown): boolean =>
  locationState instanceof Object
  && (locationState as Record<string, unknown>)[SKIP_UNSAVED_CHANGES_CONFIRMATION_KEY] === true;
